import { render, staticRenderFns } from "./TemplateFlightOnly.vue?vue&type=template&id=5258cb1d"
import script from "./TemplateFlightOnly.vue?vue&type=script&lang=js"
export * from "./TemplateFlightOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports